import { render } from "./Main.vue?vue&type=template&id=fee273bc&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=fee273bc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-fee273bc"

export default script